import { MenuDish } from '../models';

/**
 * 选菜列表（MenuDishList）行唯一标识：本地用有效 `item_id`（>0）；
 * 云端新建菜品 `item_id` 常为 0，改用云端 string `id`，避免 React 重复 key / 勾选串扰。
 * @param dish - 菜品行
 * @returns 用作 `key` / `originId` / 勾选 id 的值
 */
export function resolveMenuDishListRowId(dish: MenuDish): number | string {
    const cloudIdRaw = (dish as { id?: string | number }).id;
    /** 云端菜品 string id（详情扩展字段） */
    const cloudId =
        cloudIdRaw != null && String(cloudIdRaw).trim() !== '' ? String(cloudIdRaw) : null;
    /** 本地落库编号；云端新建可能为 0 */
    const rawItemId = dish.item_id != null ? Number(dish.item_id) : NaN;
    if (Number.isFinite(rawItemId) && rawItemId > 0) {
        return rawItemId;
    }
    if (cloudId != null) {
        return cloudId;
    }
    if (Number.isFinite(rawItemId)) {
        return rawItemId;
    }
    return 'unknown';
}
